export default "__VITE_ASSET__CJQXjr1X__"